import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { LookupType } from 'app/enum/Particles';
import { TweenLookupTable, TweenLookupTableParams } from 'particles/lookups/TweenLookupTable';

export class RectLookup implements particles.ParticleLookup {
	private _path: Array<particles.ParticleLookupProps> = [];

	constructor() {
		let steps: number = 4000;

		let targetPoints: Array<TweenLookupTableParams> = [
			{ start: { x: -0.5, y: 0.5 }, end: { x: 0.5, y: 0.5 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: 0.5, y: 0.5 }, end: { x: 0.5, y: -0.5 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: 0.5, y: -0.5 }, end: { x: -0.5, y: -0.5 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: -0.5, y: -0.5 }, end: { x: -0.5, y: 0.5 }, pointCount: Math.round(steps * 0.25) }
		];

		let lookup: TweenLookupTable = new TweenLookupTable();
		let tweenPoints: Array<geometry.Vector2> = lookup.multiTween(targetPoints);

		tweenPoints.forEach((point: geometry.Vector2, index: number) => {
			this._path.push({
				x: point.x,
				y: point.y,
				scale: 0.5,
				alpha: 1,
				rotation: 0
			});
		});
	}

	public get type(): LookupType {
		return LookupType.RECT;
	}

	public get total(): number {
		return this._path.length;
	}

	public get table(): Array<particles.ParticleLookupProps> {
		return this._path;
	}

	public get(index: number): particles.ParticleLookupProps {
		return this._path[index];
	}
}
